import { render, staticRenderFns } from "./CertificationAuthority.vue?vue&type=template&id=2cd187c1&scoped=true&"
import script from "./CertificationAuthority.vue?vue&type=script&lang=js&"
export * from "./CertificationAuthority.vue?vue&type=script&lang=js&"
import style0 from "./CertificationAuthority.vue?vue&type=style&index=0&id=2cd187c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd187c1",
  null
  
)

export default component.exports